import React, { useState, useCallback, createContext, ReactNode } from 'react';
import { ProductOptionInput } from '@shopify-multiseller/graphql/partner/types';
import { ProductOptionEditor } from '../components/ProductOptionEditor/ProductOptionEditor';

export interface ProductOptionEditorParams {
  option?: ProductOptionInput;
  options: ProductOptionInput[];
  onSave: (option: ProductOptionInput) => void;
}

export interface ProductOptionEditorContextProps {
  open: (params: ProductOptionEditorParams) => void;
  close: () => void;
}

const ProductOptionEditorContext = createContext<ProductOptionEditorContextProps | undefined>(undefined);

export const ProductOptionEditorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isProductOptionEditorOpen, setIsProductOptionEditorOpen] = useState(false);
  const [editorParams, setEditorParams] = useState<ProductOptionEditorParams | undefined>(undefined);

  const open = useCallback((params: ProductOptionEditorParams) => {
    setEditorParams(params);
    setIsProductOptionEditorOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsProductOptionEditorOpen(false);
    setEditorParams(undefined);
  }, []);

  return (
    <ProductOptionEditorContext.Provider value={{ open, close }}>
      {children}
      {isProductOptionEditorOpen && editorParams && (
        <ProductOptionEditor
          open={isProductOptionEditorOpen}
          onClose={close}
          option={editorParams.option}
          options={editorParams.options}
          onSave={editorParams.onSave}
        />
      )}
    </ProductOptionEditorContext.Provider>
  );
};

export { ProductOptionEditorContext };
